<template>
  <div class="container terms">
    <div class="blogDetailsCard">
      <h1>
        Terms & Conditions
      </h1>
      <hr>
      <div>
        <div>
          <div class="entry-content">
             <p><strong>

              Copyright Notice
             </strong>

            </p>
            <ul>
              <!-- <li>
                Make your access and shopping more convenient and efficient;
              </li> -->
              <li>Copyright © 2020 Upskill.</li>
              <li>Subject to the express provisions of these Terms, we own and control all the copyright and all other intellectual property rights, titles and interests in and relating to the videos and study materials available on Upskill Library. All the copyright and other intellectual property rights, titles and interests in and relating to the videos and study materials on Upskill Library are reserved.</li>
              <li>Subject to the express provisions of these Terms, we own and control all the copyright and all other intellectual property rights, titles and interests in and relating to the videos and study materials available on Upskill Library. All the copyright and other intellectual property rights, titles and interests in and relating to the videos and study materials on Upskill Library are reserved.</li>
            </ul>


              <p><strong>

              License to Use Upskill Library
             </strong>

            </p>

            <ul>
              <li>
                You must not download any videos or study materials from the Upskill Library to any device (television sets, internet connected smart televisions and DVD/Blu-ray players, computers, game consoles, mobile devices or handheld devices including tablets and smartphones, HDMI-connected dongles, set top boxes e.g. Apple TV, TiVo, Roku, and Google TV and/or multi-channel video programming distributor box within the territory). You are not allowed to copy/reproduce the same in whole or in part in any device, medium and /or to any third party. Without prejudice to our rights under law or equity, failing to comply with the foregoing may result in termination of your subscription and restrict your access to the Upskill Library.

              </li>
              <li>You may only use the Upskill Library subscription for your own personal purposes and must not use our videos or study materials for any other purpose including, without limitation, for commercial purposes.</li>
              <li>Videos and study materials in the Upskill Library may be viewed only for personal use or at home. Organized or public showings are not allowed.
              </li>
              <li>All videos and study materials on the Upskill Library are copyright protected and you may not republish material from the Upskill Library (including republication on another website); sell, rent or sub-license material or contents from our Website or Service; show any material from our Website or Service in public; exploit materials or contents from our Website or Service for commercial purposes; or redistribute materials or contents from our Website or Service.</li>
            </ul>


            <p><strong>Safeguarding your privacy</strong></p>
            <p>
              We take seriously the collection of any personally identifiable
              information and personal contact information (“personal
              information”) from our users and are committed to protecting each
              visitor’s privacy in accordance with these policies. We use the
              term “users” to include registered members of Upskill
              communities and any other person that accesses our websites at any
              point for any amount of time, unless designated otherwise. Please
              carefully review our information collection practices and privacy
              protections below.
            </p>
            <p><strong>How to contact us</strong></p>
            <p>
              Upskill owns and operates the Upskill.com.bd website,
              and all websites under the root domain of
              Upskill (collectively referred to in this statement as
              the ‘Website’). You may contact us directly if you have any
              questions regarding the content and material on the Website or if
              you have any questions about our privacy policies. Please contact
              us at contact[at]Upskill.com.bd or Media Officer, Upskill Dhaka
              Ltd, 9th Floor, FR Tower, 32 Kamal Ataturk Avenue, Banani C/A,
              Dhaka – 1213, Bangladesh
            </p>
            <p><strong>Collection of Personal Information </strong></p>
            <p>
              We provide various informative, educational, and entertaining
              features as part of the Website. To operate these features, we
              collect certain non-personal and personal information from our
              users for specific purposes. For Website activities that request
              personal information, you agree to provide accurate and current
              information about yourself. We may conduct contests, and/or
              special events (including registration for Upskill events)
              through the Website. To participate in these events, you must meet
              the designated criteria for participation, and minimum age
              requirements (for example, eighteen (18) years of age or older)
              for the specific event.
            </p>
            <p>
              We may retain personal information for an indefinite amount of
              time to preserve our database and to comply with local laws.
            </p>
            <p>
              <strong>Use and Collection of Information by the Website </strong>
            </p>
            <p>
              To participate on the Website, or in online activities, special
              events, contests, or other features available on the Website, you
              may be required to provide personally identifiable information
              such as your name, street and e-mail addresses, telephone number,
              birth date and gender (“personal information”). We may also survey
              users about various topics, including how we can improve our
              website and services. Response to our surveys is entirely
              voluntary.
            </p>
            <p>
              We collect personal information for several important purposes,
              including to operate our membership base, protect the security of
              our users and the site, improve our service and website,
              distribute our newsletters, notify the winners of our contests and
              sweepstakes, allow participation in specified activities or
              Interactive Areas and for future marketing and/or promotional use
              about the Website and other products and services provided by
              Upskill.
            </p>
            <p>
              The only personal information the Website obtains about you is
              information voluntarily provided by you through the Website. This
              means that a person can visit the Website and navigate through the
              Website without giving us personal information. To gauge the
              effectiveness of the Website, we may collect non-personal
              information about our members and users, such as Internet server
              and browser identification, the Internet service provider,
              clickstream information, the web page from which a person enters
              our site, webpages visited, duration of visit and domain type.
              This information does not reveal a visitor’s personal identity.
            </p>
            <p>
              We may produce certain contests, and special events with the
              support of affiliated or non-affiliated sponsors and/or
              promotional partners. The personal information collected through
              the Website in conjunction with such events may also be used for
              the marketing of additional services and events by Upskill Dhaka
              Ltd and/or its promotional partners and sponsors beyond the
              contest, and/or special event. Depending on the event, users will
              be able to either grant their approval on how their personal
              information will be used before it is collected (“opt-in”), or
              choose to deny use of their information for additional purposes
              (“opt-out”).
            </p>
            <p>
              For each contest, sweepstakes, and/or special event, we will post
              on the Website applicable rules for the event, and if necessary,
              post any supplemental terms and conditions or privacy provisions.
              To the extent there is a conflict between those privacy provisions
              and this policy, the privacy provisions for the specific event
              will govern.
            </p>
            <p>
              <strong
                >Use and Collection of Information by Operational Providers
              </strong>
            </p>
            <p>
              For the convenience of our users, we may provide the opportunity
              to purchase certain goods, merchandise and services through this
              website. Companies other than Upskill, its parents,
              partners, affiliates or subsidiaries may handle some of these
              transactions. We call these companies that conduct our e-commerce
              operations, order fulfillment and/or contract services
              “operational providers.” If you choose to use these optional
              services, our operational providers will request your personal
              information to fulfill your order or request. The voluntary
              submission of your personal information to these operational
              providers, including your order or request, will be governed by
              the specific provider’s terms of usage and privacy policies. To
              facilitate an order or request, we may share your personal
              information with the provider. The operational provider may also
              share your personal information with us. We will store this
              information in our membership database. In most instances, we
              request that our operational providers adhere to the provisions in
              our privacy policy and that such providers only share users’
              personal information with Upskill, unless necessary to
              complete a visitor’s request or order. We also request that these
              providers only use the personal information for the purpose of
              conducting the sale or fulfilling the requested service or order.
              However, you must read an operational providers privacy policy to
              determine the extent of use and disclosure of your personal
              information collected online. Upskill, its parents,
              affiliates and subsidiaries are not responsible for the
              collection, use and disclosure practices of operational providers,
              nor is Upskill responsible or liable for the products or
              services provided by operational providers.
            </p>
            <p>
              <strong
                >Our Policy on Disclosing Your Information to Parties Other than
                Upskill
              </strong>
            </p>
            <p>
              We only share or disclose your personal information with companies
              other than Upskill when it is required by law,
              disclosure is necessary to operate the website or certain website
              services, to protect the safety of our users, employees or
              property and/or when disclosure is consistent with Upskill
               practices for services that are similarly provided offline.
            </p>
            <p>
              We may in the future share personal information with our parents,
              partners, affiliates or other entities for other purposes such as
              for events. If we decide to enter into such sharing arrangements,
              we will disclose to our registered members and in this Privacy
              Policy the name of the entity(s) that we will share information
              with, what type of personal information will be shared, how the
              information will be used, and how to contact us if you do not want
              us to share your personal information (“opt-out”).
            </p>
            <p>
              We may collect and provide aggregate information about our users
              to our advertisers, sponsors, promotional partners, and
              affiliates, such as how many persons visited a particular page or
              activity or the likes and dislikes of our users, but this
              information does not include personal information about any
              individual visitor. We may obtain geographic information such as
              zip code clustering from other sources, but this aggregate
              information will not reveal any personal information about a
              specific visitor.
            </p>
            <p><strong>International Users</strong></p>
            <p>
              If you are located outside of the United States, please note that
              this Site is hosted on our computer servers in the United States.
              Any personal information collected through this Site may be
              transferred to the United States and other countries that might
              not provide an equivalent level of protection as the data
              protection laws in your home country. Your use of this Site or
              submission of any personal information will therefore constitute
              your consent to the transfer of your personal information outside
              of your home country.
            </p>
            <h3>Why Does Upskill Collect Website Use Information?</h3>
            <p>
              During your visit Upskill, we will collect certain
              website use information for a number of purposes, namely to:
            </p>
            <ul>
              <li>
                Make your access and shopping more convenient and efficient;
              </li>
              <li>Establish Site activity trends;</li>
              <li>Monitor Site performance; and</li>
              <li>Improve Site design and functionality.</li>
            </ul>
            <p><strong>Our Use of Cookies and Tracking Devices </strong></p>
            <p>
              This site uses cookies or other tracking devices. A cookie is a
              small data file that contains a unique identification number that
              a website places on your hard drive when you visit a site. The
              “cookie” is able to store information such as data about your
              computer, the type of browser you use, and how many times your
              computer visits a certain site. Cookies do not allow the Website
              to access personal information that you haven’t already provided.
              Cookies enable us to track how often users are visiting our
              website and specific pages, the number of entries in specific
              events, the estimated audience size for sponsors and advertisers,
              and user preferences. You can refuse to use cookies by turning
              them off in your browser. Please contact your browser’s software
              manufacturer for questions on how to disable your cookies. You do
              not need to have cookies turned on to use most of this site.
              However, you may find that some areas on the website will be
              slower, or may not function at all, and you may not be able to
              participate in certain activities such as contests or if the
              cookies are disabled.
            </p>
            <p>
              This site may use clear GIFs [Graphics Interchange Formats] (also
              known as pixel tags, web beacons or web bugs). A clear GIF is a
              tiny line of code that is programmed to collect certain
              information about a visit to a particular website. We use GIFs to
              gather non-personal, aggregate information on visits to our
              website, track usage of website links and assist with registration
              and other features. We do not disclose personal information that
              may be linked to our GIF collection practices to third parties.
              Other websites that you may link to through the Website may also
              use clear GIFs. Upskill, its parents and subsidiaries
              are not responsible for the use of clear GIFs by other website
              operators. Visitor’s must review other website operators’ privacy
              policies to determine the type and extent of tracking devices
              used.
            </p>
            <p>
              <strong
                >Use and Collection of Information by Advertisers and Sponsors;
                Third Party Cookies and Tracking Devices</strong
              >
            </p>
            <p>
              We use a third-party advertising company to serve ads on the
              Website. This advertising company may collect and use information
              (not including your name, address, e-mail address or telephone
              number) about your visits to our site and other websites not owned
              and operated by Upskill, and may also combine this
              information with other data about your purchases and interests
              from other online and offline sources, in order to provide
              advertisements about goods and services of interest to you. In
              addition, we may share non-personal website usage information
              about users to the Website with this company for the purpose of
              managing and targeting advertisements and for market research
              analysis on the Website and other websites. For these purposes,
              Upskill and our third party advertising company may note
              some of the pages you visit on the Website through the use of
              pixel tags (also called clear GIFs). In the course of serving
              advertisements to the Website, our third party advertisers may
              place or recognize a unique “cookie” on your computer. If you
              would like more information about the collection, use and
              disclosure practices of this third party advertising company and
              to know your choices about not having this information used by
              this company,
              <a
                href="http://www.doubleclick.com/us/corporate/privacy/privacy/default.asp?asp_object_1=&amp;"
                onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.doubleclick.com/us/corporate/privacy/privacy/default.asp?asp_object_1=&amp;', 'click here.');"
                >click here.</a
              >
            </p>
            <p>
              The Website may post banner ads and other forms of advertisements,
              and/or links to the websites of affiliate entities or of
              advertisers or sponsors who are companies that are not owned or
              operated by Upskill, its parents, affiliates or
              subsidiaries. These entities may independently solicit and collect
              personal information, or send their own cookies and/or clear GIFs
              to our users. The data collected is used in order to provide
              advertisements about goods and services that may be of interest to
              users of the Website and other interactive media and may be used
              to keep track of user response to each advertisement.
            </p>
            <p>
              We also work with third-party data analytics and online targeting
              companies. Some of these companies may use anonymous information
              (not including your name, address, email address or telephone
              number) about your visits to this and other websites in order to
              provide data and targeting recommendations based on which we may
              provide advertisements about goods and services of interest to
              you.
            </p>
            <p>
              Many large advertising networks are members of the Network
              Advertising Initiative (NAI), a cooperative on online marketing
              and analytics companies committed to building consumer awareness
              and establishing responsible business and data management
              practices. The NAI has developed a tool that allows consumers to
              opt out of targeted advertising delivered by NAI members’ ad
              networks. To learn more about opting out of targeted advertising
              or to use the tool,
              <a
                href="http://www.networkadvertising.org/managing/opt_out.asp"
                onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.networkadvertising.org/managing/opt_out.asp', 'click here');"
                >click here</a
              >.
            </p>
            <p>
              Some of the other companies who may set cookies on the Website to
              serve or present the ads that appear on the Website and to conduct
              research about those ads include:
            </p>
            <p>
              Following are the names and websites of some of the other
              companies who may set cookies on our sites to serve or present the
              ads that appear on our sites and to conduct research about the
              advertisements. You may learn about opt outing of their targeted
              advertising programs by going to their respective websites.
            </p>
            <ul>
              <li>
                comScore –
                <a
                  href="http://direct.comscore.com/docs/comScoreDirectPrivacyPolicy.pdf"
                  onclick="__gaTracker('send', 'event', 'download', 'http://direct.comscore.com/docs/comScoreDirectPrivacyPolicy.pdf');"
                  >direct.comscore.com/docs/comScoreDirectPrivacyPolicy.pdf</a
                >
              </li>
              <li>
                Google Analytics –
                <a
                  href="http://www.google.com/intl/en_ALL/privacy.html"
                  onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.google.com/intl/en_ALL/privacy.html', 'www.google.com/intl/en_ALL/privacy.html');"
                  >www.google.com/intl/en_ALL/privacy.html</a
                >
              </li>
              <li>
                Jupiter Media Metrix –
                <a
                  href="http://www.internet.com/corporate/privacy/privacypolicy.html"
                  onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.internet.com/corporate/privacy/privacypolicy.html', 'www.internet.com/corporate/privacy/privacypolicy.html');"
                  >www.internet.com/corporate/privacy/privacypolicy.html</a
                >
              </li>
              <li>
                Millward Brown IntelliQuest –
                <a
                  href="http://www.millwardbrown.com/Sites/millwardbrown/Content/Global/TermsAndConditions.aspx"
                  onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.millwardbrown.com/Sites/millwardbrown/Content/Global/TermsAndConditions.aspx', 'www.millwardbrown.com/Sites/millwardbrown/Content/Global/TermsAndConditions.aspx');"
                  >www.millwardbrown.com/Sites/millwardbrown/Content/Global/TermsAndConditions.aspx</a
                >
              </li>
              <li>
                Quantcast –
                <a
                  href="http://www.quantcast.com/docs/privacy"
                  onclick="__gaTracker('send', 'event', 'outbound-article', 'http://www.quantcast.com/docs/privacy', 'www.quantcast.com/docs/privacy');"
                  >www.quantcast.com/docs/privacy</a
                >
              </li>
            </ul>
            <p>
              Please be advised that when you link to or visit an advertiser’s
              or sponsor’s website, we may frame the site with our website logo;
              however, you will be subject to the privacy policy and terms of
              usage agreement of that website operator. Upskill, its
              parents, affiliates or subsidiaries will not be responsible for
              advertiser or sponsor ads and/or links or the content, activities,
              information collection, use and disclosure practices of the
              websites of advertisers and sponsors.
            </p>
            <p>
              We may also provide co-branded services or promotions with certain
              sponsors or other entities. As a part of these services or
              promotions, we may request the submission of your personal
              information through the Website for participation and/or
              registration. We may also share your information with the sponsor
              or entity assisting with the service or promotion to fulfill your
              request. If the co-sponsor or other entity collects your personal
              information, they may also share your information with us.
            </p>
            <p><strong>Our Security Procedures </strong></p>
            <p>
              We require our employees to protect the privacy of all information
              collected over the Website. Only employees and supervisors with
              specific authorization have access to databases containing users’
              personal information. The databases are protected in a secure
              facility. Credit card information is transmitted via encrypted
              technology. If we decide to share visitor information with other
              members of the Upskill family, the receiving entity will
              also maintain the security and integrity of personal information
              collected over the Website. That said, it is not possible to
              guarantee the security or integrity of information you disclose
              online since a sufficiently powerful attack from an unauthorized
              third party, however unlikely, could compromise your data.
            </p>
            <p>
              For the convenience of our users, we may offer a list of helpful
              website links provided by other entities and/or persons. Upskill
               does not endorse or recommend, nor is it liable for, the
              products or services of any websites not owned or operated by
              Upskill. When you visit other websites you will also be
              subject to the privacy policies and terms of usage agreements, if
              any, of that website operator.
            </p>
            <p>
              <strong>Notification of Changes in the Privacy Policy </strong>
            </p>
            <p>
              We will review our security measures and Privacy Policy on a
              periodic basis, and we may modify our policies as Upskill
               deems appropriate. We may also change or update our Privacy
              Policy if we add new services or features and will post these
              changes in this policy. We encourage you to review our Privacy
              Policy on a regular basis.
            </p>
            <p><strong>CHILDREN’S PRIVACY POLICY </strong></p>
            <p>
              Upskill respects the privacy of your child and we want
              to share with you our policies regarding children under the age of
              thirteen (13). We have developed this site to appeal to users over
              the age of thirteen (13). Although users of all ages may navigate
              through our website, we do not knowingly collect personal
              information from persons under the age of thirteen (13). If upon
              notification by a parent or guardian, or discovery by other means,
              that a child under thirteen (13) has improperly registered on this
              site by using false information, we will immediately cancel the
              child’s membership and/or participation and delete the child’s
              personally identifiable information from our records.
            </p>
            <p>
              If we decide to request information from children, we will require
              verifiable parental consent before we collect any personal
              information from children under thirteen (13) years of age, except
              in the following circumstances allowed by law:
            </p>
            <ul>
              <li>
                To provide notice and get consent from a parent or guardian;
              </li>
              <li>
                To respond to a one-time request from a child, after which we
                will immediately delete the child’s information;
              </li>
              <li>
                To fulfill a child’s request for a subscription to a online
                newspaper, magazine or specific information on a regular basis
                and we will notify the parent or guardian before we contact the
                child again;
              </li>
              <li>
                To protect the safety of a child who is participating on this
                site; and
              </li>
              <li>
                To protect the security or integrity of the site, take
                precautions against liability, respond to a validly executed
                subpoena or warrant from law enforcement, or if permitted under
                other provisions of law.
              </li>
            </ul>
            <p>
              <strong>REFUND AND CANCELLATION POLICY </strong>
            </p>
            <ul>
              <li>
                Workshops - If the workshop is cancelled for any reason before the date then all participants will be refunded 100% of the paid amount
              </li>
              <li>
                Upskill Video Library - No refund once the annual subscription is made
              </li>
              <li>
                If a user payment for a live course and if he/she is unable to join the workshop in due time, there will be no reimbursement or refund by Upskill
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: "",
      options: [
        {
          title: "Terms & Condition",
          subtitle: "By clicking accept you agree to the terms and conditions",
          img: require("../assets/images/registration-06.png")
        },
        {
          title: "Terms & Condition",
          subtitle: "By clicking accept you agree to the terms and conditions",
          img: require("../assets/images/registration-06.png")
        }
      ]
    };
  },
  created() {
    this.Loaded();
  }
};
</script>

<style scoped>
    .terms {
        max-width: 80%;
    }
</style>
